import React from "react";
import { Footprints, Truck, MapPin, ArrowUpRight } from "lucide-react";

const PLATFORMS = [
  { label: "Just Eat", class: "je", url: "#" },
  { label: "Deliveroo", class: "dlv", url: "#" },
  { label: "Uber Eats", class: "uber", url: "#" },
  { label: "Panda", class: "panda", url: "#" },
];

const ADDRESS = "1 Saltire Square, Edinburgh, EH5 1PR";
const MAPS_QUERY = encodeURIComponent("1 Saltire Square EH5 1PR Edinburgh Scotland");
const MAPS_EMBED = `https://maps.google.com/maps?q=${MAPS_QUERY}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`;

export default function WalkInPanel() {
  return (
    <section id="visit" className="py-20 lg:py-28" data-testid="walkin-section">
      <div className="container-nk">
        <div className="split-panel">
          <div className="bg-[var(--surface)] flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <Footprints size={28} className="text-gold" />
                <span className="eyebrow">// Walk In</span>
              </div>
              <h3 className="font-display text-[44px] md:text-[60px] leading-[0.95]">
                Walk In &<br />Order at the Counter
              </h3>
              <p className="mt-6 text-[15px] text-[var(--text)]/75 font-light leading-relaxed max-w-md">
                Pop in any day of the week. Browse the boards, mix dishes from
                multiple brands in one order, and grab a seat. Collection in
                minutes — no apps, no fees.
              </p>
            </div>

            {/* Address + Map */}
            <div className="mt-10">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-gold mb-2">
                Find Us in Edinburgh
              </p>
              <p
                className="font-display text-[24px] leading-tight"
                data-testid="walkin-address"
              >
                1 Saltire Square,<br />Edinburgh, EH5 1PR
              </p>

              <div
                className="mt-5 rounded-xl overflow-hidden border border-[var(--border)] aspect-[4/3] bg-[var(--surface-elevated)]"
                data-testid="walkin-map"
              >
                <iframe
                  title="Naami Kitchens location — 1 Saltire Square, Edinburgh EH5 1PR"
                  src={MAPS_EMBED}
                  width="100%"
                  height="100%"
                  style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg) brightness(0.95) contrast(0.92)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>

              <a
                href={MAPS_DIRECTIONS}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-4 text-gold font-mono text-[12px] uppercase tracking-[0.18em] hover:gap-3 transition-all"
                data-testid="walkin-directions"
              >
                <MapPin size={14} />
                Get Directions
                <ArrowUpRight size={12} />
              </a>
            </div>
          </div>

          <div className="bg-[var(--bg)] flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <Truck size={28} className="text-gold" />
                <span className="eyebrow">// Get It Delivered</span>
              </div>
              <h3 className="font-display text-[44px] md:text-[60px] leading-[0.95]">
                To Your Door,<br />Across Edinburgh
              </h3>
              <p className="mt-6 text-[15px] text-[var(--text)]/75 font-light leading-relaxed max-w-md">
                Every brand is live on the platforms you already use. One tap,
                one delivery, one happy table.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-2.5 mt-10 max-w-[360px]">
              {PLATFORMS.map((p) => (
                <a
                  key={p.label}
                  href={p.url}
                  className={`plat-btn ${p.class}`}
                  style={{ padding: "12px 14px", fontSize: "11px" }}
                  data-testid={`walkin-platform-${p.label.replace(/\s+/g, "-")}`}
                >
                  {p.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
